(() => {
  const initTabs = (root) => {
    const tabs = [...root.querySelectorAll('[data-cl-tab]')];
    const panels = [...root.querySelectorAll('[data-cl-panel]')];
    if (!tabs.length || !panels.length) return;

    const select = (tab, focus = false) => {
      tabs.forEach((item) => {
        const active = item === tab;
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
      });
      panels.forEach((panel) => {
        panel.hidden = panel.id !== tab.getAttribute('aria-controls');
      });
      if (focus) tab.focus();
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(tab));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let next = index;
        if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        select(tabs[next], true);
      });
    });

    root.ownerDocument.querySelectorAll('a[href="#reviews"], a[href="#secretmenu"], a[href="#cl-pdp-tb-tabs"]').forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        const href = link.getAttribute('href');
        select(href === '#secretmenu' ? tabs[3] : href === '#cl-pdp-tb-tabs' ? tabs[0] : tabs[2]);
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    if (window.location.hash === '#reviews') select(tabs[2]);
    if (window.location.hash === '#secretmenu') select(tabs[3]);
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-cl-tabs]').forEach(initTabs);
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', () => init(), { once: true })
    : init();

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
